// Native-platform detection WITHOUT importing @capacitor/core: the Capacitor
// WebView injects a `Capacitor` global before any app code runs, so probing
// globalThis keeps every Capacitor adapter out of the web bundle's hot path —
// the adapter modules are dynamically imported only when this returns true.

export interface CapacitorGlobalLike {
  isNativePlatform?: () => boolean;
}

export function isCapacitorNative(
  g: { Capacitor?: CapacitorGlobalLike } = globalThis as { Capacitor?: CapacitorGlobalLike },
): boolean {
  try {
    return g.Capacitor?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
}
